import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import Box from '@mui/material/Box';
import DatePicker from "../partials/pickers/DatePicker";
import ObjectPicker from "../partials/pickers/ObjectPicker";
import ObjectListPicker from "../partials/pickers/ObjectListPicker";
import ObjectSelectPicker from "../partials/pickers/ObjectSelectPicker";
import TimeRoomPicker from "../partials/pickers/TimeRoomPicker";
import SchedulePicker from "../partials/pickers/SchedulePicker";
import TimeListPicker from "../partials/pickers/TimeListPicker";
import WeekPicker from "../partials/pickers/WeekPicker";
import TimePicker from "../partials/pickers/TimePicker";
import RoomPicker from "../partials/pickers/RoomPicker";
import Checkout from "../partials/Checkout";
import ExternalIssuers from "../partials/ExternalIssuers";
import ExternalLogin from "../partials/ExternalLogin";
import BookAction from "../partials/actions/Book";
export default function Book(props) {
    return (_jsx(_Fragment, { children: _jsxs(Box, { children: [_jsx(ObjectPicker, { config: { label: "Dine and Dash" }, data: [] }), _jsx(ObjectListPicker, { source: "apptype", data: [] }), _jsx(ObjectSelectPicker, { source: "apptype", config: { label: "Afspraaktype" }, data: [] }), _jsx(ObjectSelectPicker, { source: "resource", config: { label: "Resource" }, data: [] }), _jsx(DatePicker, { source: "date" }), _jsx(TimeListPicker, {}), _jsx(SchedulePicker, {}), _jsx(TimePicker, {}), _jsx(TimeRoomPicker, {}), _jsx(WeekPicker, {}), _jsx(RoomPicker, {}), _jsx(Checkout, {}), _jsx(ExternalIssuers, {}), _jsx(ExternalLogin, {}), _jsx(BookAction, {})] }) }));
}
